import { DNS_DASH_API, ENV } from '../config/envVars'

const socketURL = DNS_DASH_API.split('//')[1]
const isLocal = /localhost/.test(DNS_DASH_API)

const BASE_URL = {
  development: DNS_DASH_API,
  pre: DNS_DASH_API,
  production: DNS_DASH_API,
}

const HOST_SOCKETS = {
  hostname: isLocal ? 'localhost' : socketURL,
  port: isLocal ? 8080 : 443,
  secure: !isLocal
}

export default {
  endpoints: {
    account: {
      signup: `${BASE_URL[ENV]}/dashboard/account/signup`,
      checkUserAndCompany: `${BASE_URL[ENV]}/dashboard/account/checkUser`,
      login: `${BASE_URL[ENV]}/dashboard/account/login`,
      externalLogin: `${BASE_URL[ENV]}/dashboard/external/login`,
      logout: `${BASE_URL[ENV]}/dashboard/account/logout`,
      resetPassword: `${BASE_URL[ENV]}/dashboard/account/resetPassword`,
      tokenRefresh: `${BASE_URL[ENV]}/dashboard/account/token/refresh`,
    },
    newAccount: {
      validateSignup: `${BASE_URL[ENV]}/dashboard/account/signup/company/validation`,
      signupCompany: `${BASE_URL[ENV]}/dashboard/account/signup/company`,
      signupOperator: `${BASE_URL[ENV]}/dashboard/account/signup/operator`,
      verify: `${BASE_URL[ENV]}/dashboard/account/signup/verify`,
      changeEmail: `${BASE_URL[ENV]}/dashboard/account/signup/sendMail`,
      sendEmailPassword: `${BASE_URL[ENV]}/dashboard/account/change-password/send-email`,
      changePassword: `${BASE_URL[ENV]}/dashboard/account/change-password`,
      checkTokenOperator: `${BASE_URL[ENV]}/dashboard/account/signup/operator/:token`,
      checkTokenPassword: `${BASE_URL[ENV]}/dashboard/account/change-password/check-token`,
    },
    operators: {
      user: `${BASE_URL[ENV]}/dashboard/dashusers`,
      channels: `${BASE_URL[ENV]}/dashboard/dashusers/channels`,
      totalOnline: `${BASE_URL[ENV]}/dashboard/operator/online`,
      putTokenFirebase: `${BASE_URL[ENV]}/dashboard/operator/token-firebase-notifications`,
      centers: `${BASE_URL[ENV]}/dashboard/operator/centers`,
      settings: `${BASE_URL[ENV]}/dashboard/operator/settings`,
      notifications: `${BASE_URL[ENV]}/operator/settings/notifications`,
      channelsList: `${BASE_URL[ENV]}/operator/channels/list`,
      available: `${BASE_URL[ENV]}/operator/logged-in/available`,
      autoAssignmentPriority: `${BASE_URL[ENV]}/operator/channels/automatic/assignment/priority`
    },
    marketing: {
      campaigns: `${BASE_URL[ENV]}/dashboard/crm-marketing/campaigns/:id`,
      templates: `${BASE_URL[ENV]}/dashboard/channel/templates`,
      oneTemplate: `${BASE_URL[ENV]}/dashboard/channel/templates/:id`,
      filters: `${BASE_URL[ENV]}/dashboard/crm-marketing/filters`,
      tickets: `${BASE_URL[ENV]}/dashboard/crm-marketing/tickets/search`,
      templateVariables: `${BASE_URL[ENV]}/dashboard/channel/templates/variables`,
      exportCsv: `${BASE_URL[ENV]}/dashboard/crm-marketing/campaigns/exportCsv`,
      launchCampaign: `${BASE_URL[ENV]}/dashboard/crm-marketing/campaigns/launch/:id`,
      notifySale: `${BASE_URL[ENV]}/dashboard/crm-marketing/campaigns/:id/sales`,
      publishWhatsapp: `${BASE_URL[ENV]}/dashboard/channel/templates/whatsapp`,
      channels: `${BASE_URL[ENV]}/dashboard/channel/templates/channels`,
      addChannel: `${BASE_URL[ENV]}/dashboard/channel/templates/addChannel`
    },
    assignation: {
      availableOperatorsUrl: `${BASE_URL[ENV]}/dashboard/assignations/available/operators`,
      userAssigned: `${BASE_URL[ENV]}/assignations/conversation/assigned`,
    },
    company: {
      companies: `${BASE_URL[ENV]}/dashboard/company/:idCompany`,
      delegations: `${BASE_URL[ENV]}/dashboard/company/:idCompany/delegations/:idDelegation`,
      brands: `${BASE_URL[ENV]}/dashboard/company/:idCompany/brands/:idBrand`,
      assignations: `${BASE_URL[ENV]}/dashboard/company/:idCompany/assignations`,
      assignationsUsers: `${BASE_URL[ENV]}/dashboard/company/:idCompany/assignations/:operatorId/users`,
      operators: `${BASE_URL[ENV]}/dashboard/company/:idCompany/dashusers/:idDashuser`,
      activation: `${BASE_URL[ENV]}/dashboard/operator/send/activation`,
      plans: `${BASE_URL[ENV]}/dashboard/company/:idCompany/plans`,
      commissions: `${BASE_URL[ENV]}/dashboard/company/:idCompany/commissions`,
      configurations: `${BASE_URL[ENV]}/dashboard/company/:idCompany/configurations`,
      nightTime: `${BASE_URL[ENV]}/dashboard/company/:idCompany/configurations/nightTime`,
      categories: `${BASE_URL[ENV]}/dashboard/category/:categoryId`,
      newCategories: `${BASE_URL[ENV]}/categories`,
      categoriesBrandsDelegations: `${BASE_URL[ENV]}/dashboard/category`,
      autoDisabled: `${BASE_URL[ENV]}/company/settings/operator/auto-disabled`,
      automaticAssigment: `${BASE_URL[ENV]}/company/settings/automatic/assignment/activate`
    },
    configurations: {
      aocs: `${BASE_URL[ENV]}/channels/aocs`,
      qrPoster: `${BASE_URL[ENV]}/channels/qr-poster`,
    },
    botConsole: {
      newVa: `${BASE_URL[ENV]}/dashboard/botConsoleHeader`,
      botHeader: `${BASE_URL[ENV]}/dashboard/botConsoleHeader/:botId`,
      vaList: `${BASE_URL[ENV]}/dashboard/botConsoleHeader/consolePreview`,
      trainBot: `${BASE_URL[ENV]}/dashboard/botConsoleHeader/:botId/train_model`,
      intents: `${BASE_URL[ENV]}/dashboard/botConsoleHeader/:botId/intents`,
      intentDetails: `${BASE_URL[ENV]}/dashboard/botConsoleHeader/:botId/intents/:intentId/details`,
      intent: `${BASE_URL[ENV]}/dashboard/botConsoleHeader/:botId/intents/:intentId/`,
      intentStatus: `${BASE_URL[ENV]}/dashboard/botConsoleHeader/:botId/intents/:intentId/status`,
      setting: `${BASE_URL[ENV]}/dashboard/botConsoleHeader/setting`,
      smartChatHealth: `${BASE_URL[ENV]}/dashboard/botConsoleHeader/smartchat/health/:botId`
    },
    botConsoleGenerative: {
      resourcesList: `${BASE_URL[ENV]}/bot-console/generative/resource/list`,
      addResource: `${BASE_URL[ENV]}/bot-console/generative/resource/add/file`,
      deleteResource: `${BASE_URL[ENV]}/bot-console/generative/resource/delete`,
      hasUpdatedResources: `${BASE_URL[ENV]}/dashboard/botConsoleHeader/`,
    },
    credentials: {
      credentialHeaders: `${BASE_URL[ENV]}/dashboard/credentials`,
      credentialByKey: `${BASE_URL[ENV]}/dashboard/credentials/:type/:key`,
      credentialById: `${BASE_URL[ENV]}/dashboard/credential/:key/:id`,
      linkExpireTime: `${BASE_URL[ENV]}/dashboard/credentials/paymentGateway/linkExpireTime`,
    },
    channels: {
      get: `${BASE_URL[ENV]}/dashboard/company/:idCompany/channels`,
      set: `${BASE_URL[ENV]}/dashboard/company/:idCompany/channel/:channel`,
      qr: `${BASE_URL[ENV]}/dashboard/channel/qr`,
      deleteEndpoint: `${BASE_URL[ENV]}/dashboard/company/:id/channel/:channel`,
      sendConnectionAPIToken: `${BASE_URL[ENV]}/channels/send-api-token`,
      getList: `${BASE_URL[ENV]}/channels/list?key=:key&hub=:hub`,
      getById: `${BASE_URL[ENV]}/channels/:channelId`,
      deleteById: `${BASE_URL[ENV]}/channels/:channelId?confirmDelete=true`,
      getSchema: `${BASE_URL[ENV]}/channels/new?key=:key&hub=:hub`,
      publishApp: `${BASE_URL[ENV]}/channels/publish/:channelId`,
      activate: `${BASE_URL[ENV]}/channels/activate/:channelId`,
      new: `${BASE_URL[ENV]}/channels/new`,
      uri: `${BASE_URL[ENV]}/channels/oauth/uri`,
      error: `${BASE_URL[ENV]}/channels/oauth/uri/error`,
      mail: `${BASE_URL[ENV]}/channels/mail/oauth/:provider`,
      update: `${BASE_URL[ENV]}/channels/:channelID`,
      verifyWhatsappChannel: `${BASE_URL[ENV]}/channels/whatsapp/verify-config`,
      getCodeRequestMethod: `${BASE_URL[ENV]}/channels/whatsapp/request-code`,
      verifyWhatsappCode: `${BASE_URL[ENV]}/channels/whatsapp/verify-code`,
      imapVerification: `${BASE_URL[ENV]}/channels/validate/imap`,
      getChannelsToRedirect: `${BASE_URL[ENV]}/channels/list?key=chatweb&redirect=true`,
    },
    providers: {
      available: `${BASE_URL[ENV]}/dashboard/providers/available/:type`,
    },
    insurances: `${BASE_URL[ENV]}/dashboard/insurances`,
    roles: {
      roles: `${BASE_URL[ENV]}/dashboard/roles`,
      infoRoles: `${BASE_URL[ENV]}/dashboard/roles/info`,
      rolesPermissionsList: `${BASE_URL[ENV]}/roles/permissions/list`,
      rolesPermissionsUpdate: `${BASE_URL[ENV]}/roles/permissions/update`,
      operatorPermissions: `${BASE_URL[ENV]}/operator/permissions`
    },
    payment: {
      methods: `${BASE_URL[ENV]}/dashboard/payment/method`,
    },
    users: {
      byListsUrl: `${BASE_URL[ENV]}/dashboard/users/list`,
      byQueryUrl: `${BASE_URL[ENV]}/dashboard/users/query`,
      bySearchUrl: `${BASE_URL[ENV]}/dashboard/users/search`,
      exportCsvUrl: `${BASE_URL[ENV]}/dashboard/users/exportCsv`,
      updateStateUrl: `${BASE_URL[ENV]}/dashboard/users/list/updateState`,
      addressUrl: `${BASE_URL[ENV]}/dashboard/users/address/:userId`,
      passengersUrl: `${BASE_URL[ENV]}/dashboard/users/passengers`,
      externalUpdateUrl: `${BASE_URL[ENV]}/dashboard/user/externalUpdate/:ticketId`,
      getAvatarUrl: `${BASE_URL[ENV]}/dashboard/users/update/profile/image`,
      filters: `${BASE_URL[ENV]}/dashboard/users/filters`,
      webviewLink: `${BASE_URL[ENV]}/dashboard/users/webview/:userId`,
    },
    bookings: {
      post: `${BASE_URL[ENV]}/dashboard/bookings`,
      getDetails: `${BASE_URL[ENV]}/dashboard/bookings/:bookingId`,
      getDetailsFromApi: `${BASE_URL[ENV]}/dashboard/bookings/:bookingId?updateFromApi=paramUpdateFromApi`,
      getInsurance: `${BASE_URL[ENV]}/dashboard/bookings/insurance/:bookingId`,
      cancel: `${BASE_URL[ENV]}/dashboard/bookings/:bookingId/cancel`,
      void: `${BASE_URL[ENV]}/dashboard/bookings/:bookingId/ticket/void`,
      emit: `${BASE_URL[ENV]}/dashboard/bookings/:bookingId/ticket/emit`,
      modify: `${BASE_URL[ENV]}/dashboard/bookings/:bookingId/modify`,
      exportCsv: `${BASE_URL[ENV]}/dashboard/bookings/exportCsv`,
      getBookings: `${BASE_URL[ENV]}/dashboard/bookings/plugin/:userId`,
      getFilters: `${BASE_URL[ENV]}/dashboard/bookings/filters`,
    },
    modules: {
      add: `${BASE_URL[ENV]}/dashboard/module/add/:moduleName`,
      remove: `${BASE_URL[ENV]}/dashboard/module/remove/:moduleName`,
      validateGrafanaAccess: `${BASE_URL[ENV]}/dashboard/module/valid/grafana/access`,
    },
    plugins: {
      search: {
        query: `${BASE_URL[ENV]}/dashboard/products/search`,
        cancelSearch: `${BASE_URL[ENV]}/dashboard/products/cancelSearch`,
        results: `${BASE_URL[ENV]}/dashboard/products/results`,
      },
      payment: {
        create_new_link: `${BASE_URL[ENV]}/dashboard/payment/reset`,
        // cancel_link: `${BASE_URL[ENV]}/dashboard/payment/cancel`,
        custom_link: `${BASE_URL[ENV]}/dashboard/payment/custom`, //-mismo
        generate_bill: 'https://dev.correyvuela.com/external/billing', //No se usa y no existe
        orders: `${BASE_URL[ENV]}/dashboard/payment/orders/:userId`,
        order: `${BASE_URL[ENV]}/dashboard/payment/order/:orderId`,
        refund: `${BASE_URL[ENV]}/dashboard/payment/refund`,
        // nuevos endpoints
        all_payments: `${BASE_URL[ENV]}/conversations/payments/list/`,
        cancel_link: `${BASE_URL[ENV]}/conversations/payments/cancel`,
        payment_id: `${BASE_URL[ENV]}/conversations/payments/get`,
        renewLink: `${BASE_URL[ENV]}/conversations/payments/extend`
      },
      locators: {
        sendLocator: `${BASE_URL[ENV]}/dashboard/payment/billing`,
      },
      passengers: `${BASE_URL[ENV]}/dashboard/users/passengers`,
      ecommerce: `${BASE_URL[ENV]}/ecommerce`,
      topicSummary: {
        generate: `${BASE_URL[ENV]}/conversations/topics/generate`,
        list: `${BASE_URL[ENV]}/conversations/topics/list`,
      },
      trackingUserInfo: `${BASE_URL[ENV]}/conversations/web/track/get`,
      trackingUserHistory: `${BASE_URL[ENV]}/conversations/web/track/history`,
    },
    schedules: `${BASE_URL[ENV]}/dashboard/schedules`,
    nauta: {
      bot_buttons: `${BASE_URL[ENV]}/dashboard/bot-buttons`,
      lauch_process: `${BASE_URL[ENV]}/dashboard/user/processNauta`,
    },
    mnemonics: {
      seen: `${BASE_URL[ENV]}/dashboard/operator/seen/messages`,
      get: `${BASE_URL[ENV]}/operator/logged-in/mnemonics`
    },
    pools: {
      filters: `${BASE_URL[ENV]}/pools/filters`,
      main: `${BASE_URL[ENV]}/pools/main/users`,
      assigned: `${BASE_URL[ENV]}/pools/assigned/users`,
      lists: {
        lists: `${BASE_URL[ENV]}/pools/lists`,
        user: `${BASE_URL[ENV]}/pools/lists/user/:userId`,
        edit: `${BASE_URL[ENV]}/pools/lists/edit`,
      },
      categories: `${BASE_URL[ENV]}/pools/filters/categories/list`,
    },
    inchat: {
      conversation: `${BASE_URL[ENV]}/inchat/conversation/:conversationId`,
      conversationList: `${BASE_URL[ENV]}/inchat/conversation/list`,
      mainMenu: `${BASE_URL[ENV]}/inchat/menu/main`,
      sections: `${BASE_URL[ENV]}/inchat/section/:groupId`,
      sectionsOrder: `${BASE_URL[ENV]}/inchat/section/order/items`,
      sectionAll: `${BASE_URL[ENV]}/inchat/section/all`,
      createConversation: `${BASE_URL[ENV]}/inchat/conversation/create`,
      searchUser: `${BASE_URL[ENV]}/inchat/user/search`,
      infoConversation: `${BASE_URL[ENV]}/inchat/conversation/info`,
      sendMessage: `${BASE_URL[ENV]}/inchat/message`,
      conversationMessages: `${BASE_URL[ENV]}/inchat/conversation/messages`,
      resource: `${BASE_URL[ENV]}/inchat/resource`,
      actionConversation: `${BASE_URL[ENV]}/inchat/conversation/action`,
      allChannels: `${BASE_URL[ENV]}/inchat/conversation/channels`,
      saveMessage: `${BASE_URL[ENV]}/inchat/user/message/save`,
      removeSaveMessage: `${BASE_URL[ENV]}/inchat/user/message/unsave`,
      savedList: `${BASE_URL[ENV]}/inchat/user/message/save/list`,
      getThreadsByMessage: `${BASE_URL[ENV]}/inchat/conversation/threads`,
      getOperator: `${BASE_URL[ENV]}/inchat/user/:userId`,
      filesConversation: `${BASE_URL[ENV]}/inchat/conversation/files`,
      createSection: `${BASE_URL[ENV]}/inchat/section`,
      allScheduledMessages: `${BASE_URL[ENV]}/inchat/message/schedule/all`,
      scheduleMessage: `${BASE_URL[ENV]}/inchat/message/schedule`,
      scheduleMessageById: `${BASE_URL[ENV]}/inchat/message/schedule/:messageId`,
      addReaction: `${BASE_URL[ENV]}/inchat/reaction/add`,
      removeReaction: `${BASE_URL[ENV]}/inchat/reaction/remove`,
      showTotalReactions: `${BASE_URL[ENV]}/inchat/reaction/show/total`,
      showDetailsReactions: `${BASE_URL[ENV]}/inchat/reaction/show/details`,
      actionMessage: `${BASE_URL[ENV]}/inchat/message/:messageId`,
      pinAdd: `${BASE_URL[ENV]}/inchat/pin/add`,
      pinRemove: `${BASE_URL[ENV]}/inchat/pin/remove`,
      pinList: `${BASE_URL[ENV]}/inchat/pin/list`,
      draftAdd: `${BASE_URL[ENV]}/inchat/draft/add`,
      draftUpdate: `${BASE_URL[ENV]}/inchat/draft/update`,
      draftRemove: `${BASE_URL[ENV]}/inchat/draft/remove`,
      draftConversation: `${BASE_URL[ENV]}/inchat/draft/conversation`,
      draftList: `${BASE_URL[ENV]}/inchat/draft/list`,
      joinLink: `${BASE_URL[ENV]}/inchat/join/link/create`,
      members: `${BASE_URL[ENV]}/inchat/conversation/members`,
      seenMessages: `${BASE_URL[ENV]}/inchat/message/seen`,
    },
    conversation: {
      messages: `${BASE_URL[ENV]}/dashboard/chat/messages`,
      subjects: `${BASE_URL[ENV]}/dashboard/chat/messages/subject/:userId`,
      deferred: `${BASE_URL[ENV]}/dashboard/chat/messages/deferred`,
      notes: `${BASE_URL[ENV]}/dashboard/chat/note`,
      update_user_url: `${BASE_URL[ENV]}/dashboard/users`,
      get: `${BASE_URL[ENV]}/dashboard/user/:id`,
      userCategories: `${BASE_URL[ENV]}/dashboard/category/user`,
      getChannels: `${BASE_URL[ENV]}/conversations/opt-out/channels/:type`,
      sendSmsMessage: `${BASE_URL[ENV]}/conversations/out-date/message/send`,
      getUsers: `${BASE_URL[ENV]}/conversations/opt-out/search/users`,
      sendMsg: `${BASE_URL[ENV]}/conversations/opt-out/message/send`,
      drafts: `${BASE_URL[ENV]}/conversations/drafts`,
      draftById: `${BASE_URL[ENV]}/conversations/drafts/:id`,
      state: `${BASE_URL[ENV]}/conversations/changes/state`,
      signature: `${BASE_URL[ENV]}/conversations/signatures`,
      msgSync: `${BASE_URL[ENV]}/conversations/sync/account`,
      read: `${BASE_URL[ENV]}/conversations/read`,
      templatesByChannel: `${BASE_URL[ENV]}/conversations/templates/list/byChannel`,
      addMessagesCategories: `${BASE_URL[ENV]}/conversations/messages/categories/add`,
      removeMessagesCategories: `${BASE_URL[ENV]}/conversations/messages/categories/remove`,
      updateAllMessagesCategories: `${BASE_URL[ENV]}/conversations/messages/categories/update-all`,
      addReactions: `${BASE_URL[ENV]}/conversations/reactions/add`,
      removeReactions: `${BASE_URL[ENV]}/conversations/reactions/remove`,
      redirectUrl: `${BASE_URL[ENV]}/conversations/redirect/link/create`,
      getDetails: `${BASE_URL[ENV]}/conversations/details/get`,
      getCustomDetails: `${BASE_URL[ENV]}/conversations/details/custom`,
      suggestions: `${BASE_URL[ENV]}/conversations/suggestions/:conversationId`,
      rejectSuggestions: `${BASE_URL[ENV]}/conversations/suggestions/reject/:conversationId`,
    },
    sentiment: {
      activate: `${BASE_URL[ENV]}/sentiment/activate`,
      change: `${BASE_URL[ENV]}/sentiment/change`,
    },
    bitrix: {
      createCrm: `${BASE_URL[ENV]}/crm/create/lead`,
    },
    surveys: {
      get: `${BASE_URL[ENV]}/dashboard/surveys`,
      new: `${BASE_URL[ENV]}/dashboard/surveys/new`,
      byId: `${BASE_URL[ENV]}/dashboard/surveys/:surveyId`,
      url: `${BASE_URL[ENV]}/dashboard/surveys/url`
    },
    resource: {
      resources: `${BASE_URL[ENV]}/dashboard/resources`,
      companyResources: `${BASE_URL[ENV]}/dashboard/companyResources`,
      refreshFile: `${BASE_URL[ENV]}/dashboard/companyResources/share/:resourceId`,
      userResources: `${BASE_URL[ENV]}/dashboard/userResources/:userId`,
      updateUserResource: `${BASE_URL[ENV]}/dashboard/userResources/:resourceId`,
    },
    smartChat: {
      header: `${BASE_URL[ENV]}/chatbot/header`,
      deploy: `${BASE_URL[ENV]}/chatbot/header/deploy`,
      setDefault: `${BASE_URL[ENV]}/chatbot/header/setDefault`,
      earlierVersion: `${BASE_URL[ENV]}/chatbot/header/earlier-version`,
      processesList: `${BASE_URL[ENV]}/chatbot/processes/list/:headerId`,
      processesPartialList: `${BASE_URL[ENV]}/chatbot/processes/partial/list/:headerId`,
      processes: `${BASE_URL[ENV]}/chatbot/processes`,
      processesById: `${BASE_URL[ENV]}/chatbot/processes/:processId`,
      processPartialUpdate: `${BASE_URL[ENV]}/chatbot/processes/partial/update`,
      copyTo: `${BASE_URL[ENV]}/chatbot/processes/copyTo`,
      groupsNew: `${BASE_URL[ENV]}/chatbot/messages/groups/new`,
      groupsEditName: `${BASE_URL[ENV]}/chatbot/messages/groups/name`,
      groupsList: `${BASE_URL[ENV]}/chatbot/messages/groups`,
      getMessageGroup: `${BASE_URL[ENV]}/chatbot/messages`,
      deleteGroup: `${BASE_URL[ENV]}/chatbot/messages/groups/delete`,
      groupOrder: `${BASE_URL[ENV]}/chatbot/messages/groups/order`,
      messageNew: `${BASE_URL[ENV]}/chatbot/messages`,
      messageDelete: `${BASE_URL[ENV]}/chatbot/messages/delete`,
      messageOrder: `${BASE_URL[ENV]}/chatbot/messages/groups/order/messages`,
      processCategories: `${BASE_URL[ENV]}/chatbot/categories`,
      processCategory: `${BASE_URL[ENV]}/chatbot/categories/:categoryId`,
      labels: `${BASE_URL[ENV]}/chatbot/labels`,
      label: `${BASE_URL[ENV]}/chatbot/labels/:labelId`,
    },
    smartChatEcommerce: {
      statusShop: `${BASE_URL[ENV]}/ecommerce/shop/status`,
    },
    countries: `${BASE_URL[ENV]}/dashboard/countries`,
    autocomplete: {
      places: `${BASE_URL[ENV]}/dashboard/autocomplete/places`,
      locations: `${BASE_URL[ENV]}/dashboard/autocomplete/locations`,
    },
    contentTexts: `${BASE_URL[ENV]}/dashboard/content-texts`,
    shorten: `${BASE_URL[ENV]}/dashboard/shorten-url`,
    translations: {
      translation: `${BASE_URL[ENV]}/translations/dashboard`,
      remove: `${BASE_URL[ENV]}/translations/dashboard/remove`,
    },
    meet: {
      link: `${BASE_URL[ENV]}/meetings/link/create`,
    },
    deleteManager: {
      deleteConversation: `${BASE_URL[ENV]}/conversations/remove`,
      deleteMessage: `${BASE_URL[ENV]}/conversations/remove/message`,
      deleteComment: `${BASE_URL[ENV]}/conversations/remove/comment`,
      deleteSubject: `${BASE_URL[ENV]}/conversations/remove/subject`,
    },
    exportManager: {
      exportConversation: `${BASE_URL[ENV]}/conversations/export`
    },
    dashNotifications: {
      dashNotifications: `${BASE_URL[ENV]}/operator/dash-notifications`,
      notificationsRead: `${BASE_URL[ENV]}/operator/dash-notifications/read`,
      notificationsHasNew: `${BASE_URL[ENV]}/operator/dash-notifications/hasNew`,
    },
    searchEngine: {
      deepSearch: `${BASE_URL[ENV]}/global-search/deep-search`,
      searchPreview: `${BASE_URL[ENV]}/global-search/search-preview`,
      searchSuggestion: `${BASE_URL[ENV]}/global-search/search-suggestion`
    },
    massiveAction: `${BASE_URL[ENV]}/massive-action`,
    folders: {
      list: `${BASE_URL[ENV]}/folders/list`,
      create: `${BASE_URL[ENV]}/folders/create`,
      delete: `${BASE_URL[ENV]}/folders/delete`,
      byId: `${BASE_URL[ENV]}/folders/:folderId`
    },
    intranet: {
      translations: {
        list: `${BASE_URL[ENV]}/intranet/translations/list`,
        update: `${BASE_URL[ENV]}/intranet/translations/update`,
        remove: `${BASE_URL[ENV]}/intranet/translations/remove`,
        labelsList: `${BASE_URL[ENV]}/intranet/translations/labels/list`,
        createLabel: `${BASE_URL[ENV]}/intranet/translations/labels/create`,
        updateLabel: `${BASE_URL[ENV]}/intranet/translations/labels/update`
      }
    },
    metrics: {
      kpisPanels: `${BASE_URL[ENV]}/kpiPanels/panels`,
      datasets: `${BASE_URL[ENV]}/metrics/datasets/`,
    },
    marketPlace: {
      slack: {
        prepareAdmins: `${BASE_URL[ENV]}/marketplace/slack/oauth-prepare-admins`,
        prepareUsers: `${BASE_URL[ENV]}/marketplace/slack/oauth-prepare-users`,
        slackActiveWorkspaces: `${BASE_URL[ENV]}/marketplace/slack/slack-active-workspaces`,
        userPermissionSlack: `${BASE_URL[ENV]}/marketplace/slack/user-permission-slack`,
        switchSlackActivate: `${BASE_URL[ENV]}/marketplace/slack/slack-activation`,
        getOperatorCompanyWorkspaces: `${BASE_URL[ENV]}/marketplace/slack/operator-company-workspaces`,
        signOutSlackCompany: `${BASE_URL[ENV]}/marketplace/slack/sign-out-slack-company`,
        signOutSlackOperator: `${BASE_URL[ENV]}/marketplace/slack/sign-out-slack-operator`
      }
    },
    external: {
      identification: {
        getOne: `${BASE_URL[ENV]}/integrations/external/identification/get-one`,
        identification: `${BASE_URL[ENV]}/integrations/external/identification`,
        identificationActivate: `${BASE_URL[ENV]}/integrations/external/identification/activate`,
        identificationTest: `${BASE_URL[ENV]}/integrations/external/identification/test`,
      },
      customFields: {
        addCustomField: `${BASE_URL[ENV]}/integrations/external/identification/custom/fields`,
        listCustomFields: `${BASE_URL[ENV]}/integrations/external/identification/custom/fields/list`,
        removeCustomField: `${BASE_URL[ENV]}/integrations/external/identification/custom/fields/delete`,
        updateCustomField: `${BASE_URL[ENV]}/integrations/external/identification/custom/fields/update`,
      }
    }
  },
  auth: {
    facebook: {
      appId: '922704847940527',
      botId: 'nixi1bot',
    },
    telegram: {
      botId: 'nixi1_business_bot',
    },
    whatsapp: {
      botId: '34911060881',
    },
    sms: {
      botId: '+34955160700',
    },
  },
  dashboardService: HOST_SOCKETS,
  dnsDashboard: BASE_URL[ENV]
}
